import { getEmptyParagraphNode } from '@doltech/utils/lib/editor';
import { nanoid } from 'nanoid';
import { Node } from 'slate';

export const CARD_LOGIC_ELEMENT_TYPE = 'CardLogic';


export const CARD_LOGIC_COLUMN_ELEMENT_TYPE = 'CardLogicColumn';
export const CARD_LOGIC_COLUMN_CLASS_NAME = 'card-logic-column-element';

// Header
export const CARD_LOGIC_HEADER_CELL_ELEMENT_TYPE = 'CardLogicHeaderCell';
export const CARD_LOGIC_HEADER_CELL_CLASS_NAME = 'card-logic-header-cell-element';
export const CARD_LOGIC_HEADER_CELL_COLOR_SELECTION_CLASS_NAME = 'header-cell-color-selection';

// Normal Cell
export const CARD_LOGIC_CELL_ELEMENT_TYPE = 'CardLogicCell';
export const CARD_LOGIC_CELL_CLASS_NAME = 'card-logic-cell-element';

export const VOCAB_CARD = 'VOCAB_CARD';

export const ELEMENT_BY_ID_ATTRIBUTES = 'data-element-id';

export const generateSingleCardLogicHeaderCell = () => {
  return {
    id: nanoid(),
    type: CARD_LOGIC_HEADER_CELL_ELEMENT_TYPE,
    backgroundColor: 'transparent',
    textAlign: 'left',
    children: [{ text: 'Header' }],
  };
};

export const generateSingleCardLogicCell = () => {
  return {
    id: nanoid(),
    type: CARD_LOGIC_CELL_ELEMENT_TYPE,
    textAlign: 'left',
    children: [getEmptyParagraphNode()],
  };
};

export const generateSingleColumnLogicCell = () => {
  return {
    id: nanoid(),
    type: CARD_LOGIC_COLUMN_ELEMENT_TYPE,
    children: [generateSingleCardLogicHeaderCell(), generateSingleCardLogicCell()],
  };
};

// Initial CardLogic State
export const generateSingleCardLogicNode = () => {
  return {
    id: nanoid(),
    type: CARD_LOGIC_ELEMENT_TYPE,
    children: [generateSingleColumnLogicCell(), generateSingleColumnLogicCell()],
  } as Node;
};
